import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import AllPlaysHome from './pages/AllPlaysHome';
import History from './pages/History';

function App() {
  const basename = (process.env.PUBLIC_URL || '').trim() || undefined;

  return (
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<AllPlaysHome />} />
        <Route path="/lottery" element={<AllPlaysHome />} />
        <Route path="/featured" element={<Home />} />
        <Route path="/history" element={<History />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
